import React, { Component } from "react";
import { connect } from "react-redux";
import { actions } from 'react-redux-form';

import CustomSearchableDropdownWrapper from "../../../../../../common/custom-form/custom-dropdown/custom-searchable-dropdown-wrapper";
import CustomSearchableSelectWrapper from "../../../../../../common/custom-form/custom-searchable-select-wrapper.component";
import { InputFieldFloatingLabel as InputField, SelectFieldFloatingLabel as Select } from "../../../../../../common/custom-form/select-filter.component";
import Translation from "../../../../../../common/translation/translation.component";
import DATEPICKER_OR from "../../../../../../common/custom-form/custom-date-picker.component";
import { MAX_LENGTH } from "../../../../../../../constants/external-constants";
import { isNotAccountType3 } from "../../../../../../../utils/helpers.utils";
class BillingTransactionDetails extends Component {

    constructor(props) {
        super(props);
        this.state = {
            apVendorPage: 1
        }
    }
    componentDidMount() {
    }

    onChangeVendor(vendorId) {
        const { selectVendorId, resetVendorField, fetchFinanceContractbyVendor, fetchAPVendorsbyVendor } = this.props;
        if (vendorId && typeof vendorId !== String) {
            selectVendorId(vendorId);
            fetchFinanceContractbyVendor(1, "", vendorId);
            fetchAPVendorsbyVendor(1, "", vendorId);
        }
        resetVendorField(vendorId);
    }

    onChangeContractId(contractId) {
        const { selectedContractId, resetContractField } = this.props;

        if (contractId) {
            selectedContractId(contractId);
        }
        else {
            resetContractField();
        }
    }

    loadMoreActiveVendors = (searchString) => {
        const { billingAccountDetails } = this.props;
        this.props.onScrollVendors(billingAccountDetails.activeVendorsPage + 1, searchString);
    }

    loadMoreContractID = (searchString) => {
        const { billingAccountDetails } = this.props;
        this.props.onScrollContract(billingAccountDetails.ContractCodePage + 1, searchString);
    }

    loadMoreAPVendors = (searchString) => {
        const { APVendorsPage } = this.props.billingAccountDetails;
        this.props.onScrollApVendors(APVendorsPage + 1, searchString);
    }

    searchActiveVendor = (searchString) => {
        this.props.onSearchActiveVendors(searchString);
    } 

    searchContractID = (searchString) => {
        this.props.onSearchContractID(searchString);
    }

    searchAPVendor = (searchString) => {
        this.props.onSearchAPVendors(searchString);
    }

    render() {
        const { activeVendors
            , accountTypes
            , accountStatus
            , accountFirstBill
            , accountLevel
            , accounInterval
            , financeContractByVendor
            , masterAccountByVendor
            , hasMoreActiveVendors
            , hasMoreContracts
            , hasMoreAPVendors
            , apVendorsByVendor
            , hasMoreContractCodes 
        } = this.props.billingAccountDetails;

        const { selectedApVendor, billingAccountForm, accountNumAlreadyExist } = this.props;
        const { billingAccount } = billingAccountForm


        return (
            <>
                <div className="details-field-container capital-uppercase">
                    <CustomSearchableDropdownWrapper
                        label={<Translation translationKey={"vendor"} />}
                        options={activeVendors}
                        selected={billingAccount?.vendorDetailId}
                        onChange={(e) => this.onChangeVendor(e)}
                        placeholder={`${this.props.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='billingAccountForm.billingAccount.vendorDetailId'
                        //isNullable={true}
                        tagName='tagName'
                        optionLabelKey={{
                            Key: 'VendorDetailId',
                            Value: 'VendorName'
                        }}
                        requiredField={true}
                        maxLength={MAX_LENGTH.inputText}
                        disabled={false}
                        onSearchChange={this.searchActiveVendor}
                        onLoadMore={(val) => this.loadMoreActiveVendors(val)}
                        hasMore={hasMoreActiveVendors}
                    />

                    <Select
                        className="form-select required"
                        label={<Translation translationKey={"account_type_capital"} />}
                        value={billingAccount.accountTypeId}
                        options={accountTypes}
                        placeholder={this.props.toLocaleLanguage('select_placeholder', false)}
                        fieldProp='billingAccountForm.billingAccount.accountTypeId'
                        disabled={false}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"account_number"} />}
                        value={billingAccount.billingAccountNumber}
                        fieldProp='billingAccountForm.billingAccount.billingAccountNumber'
                        disabled={false}
                        requiredField={true}
                        placeholder={this.props.toLocaleLanguage('enter_text_placeholder')}
                        maxLength={MAX_LENGTH.inputText}
                        isError={accountNumAlreadyExist}
                    />

                    <CustomSearchableSelectWrapper
                        label={<Translation translationKey={"master_account_number"} />}
                        options={masterAccountByVendor}
                        selected={isNotAccountType3(billingAccount.accountTypeId) ? '' : billingAccount.masterAccountId}
                        onChange={() => { }}
                        placeholder={isNotAccountType3(billingAccount.accountTypeId) ? '' : `${this.props.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='billingAccountForm.billingAccount.masterAccountId'
                        tagName='masterAccountId'
                        optionLabelKey={{
                            Key: 'Key',
                            Value: 'Value'
                        }}
                        maxLength={MAX_LENGTH.inputText}
                        disabled={isNotAccountType3(billingAccount.accountTypeId) ? true : false}
                        requiredField={isNotAccountType3(billingAccount.accountTypeId) ? false : true}
                    />

                    <Select
                        className="form-select required"
                        label={<Translation translationKey={"account_status"} />}
                        value={billingAccount.accountStatusId}
                        options={accountStatus}
                        placeholder={`${this.props.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='billingAccountForm.billingAccount.accountStatusId'
                        disabled={false}
                        isError={false}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"currency"} />}
                        value={billingAccount.currency}
                        fieldProp='billingAccountForm.billingAccount.currency'
                        disabled={true}
                    />

                    <CustomSearchableDropdownWrapper
                        label={<Translation translationKey={"contract_id"} />}
                        options={financeContractByVendor}
                        selected={billingAccount.financeContractId}
                        onChange={(e) => this.onChangeContractId(e)}
                        isNullable={true}
                        placeholder={`${this.props.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='billingAccountForm.billingAccount.financeContractId'
                        tagName='financeContractId'
                        optionLabelKey={{
                            Key: 'FinanceContractId',
                            Value: 'ContractCode'
                        }}
                        maxLength={MAX_LENGTH.inputText}
                        disabled={false}

                        onSearchChange={this.searchContractID}
                        onLoadMore={this.loadMoreContractID}
                        hasMore={hasMoreContractCodes}
                  />

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"service_type"} />}
                        value={billingAccount.serviceTypeName}
                        fieldProp='billingAccountForm.billingAccount.serviceTypeName'
                        disabled={true}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"invoice_format"} />}
                        value={billingAccount.invoiceFormat}
                        fieldProp='billingAccountForm.billingAccount.invoiceFormat'
                        disabled={false}
                        requiredField={true}
                        placeholder={this.props.toLocaleLanguage('enter_text_placeholder')}
                        maxLength={MAX_LENGTH.inputText}
                    />

                    <DATEPICKER_OR
                        dateOnly={true}
                        label={<Translation translationKey={"expected_invoice_receipt_date"} />}
                        placeholder={`${this.props.toLocaleLanguage('select_date')}`}
                        startDate={billingAccount.invoiceReceiptDate}
                        selectedDate={(date) => this.props.FormChange("billingAccountForm.billingAccount.invoiceReceiptDate", date)}
                        isDisable={false}
                        requiredField={true}
                        customClass={"billing-account"}
                    />

                    <Select
                        className="form-select required"
                        label={<Translation translationKey={"invoice_interval"} />}
                        value={billingAccount.accountIntervalId}
                        options={accounInterval}
                        placeholder={`${this.props.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='billingAccountForm.billingAccount.accountIntervalId'
                        disabled={false}
                        requiredField={true}
                    />

                    <Select
                        className="form-select required"
                        label={<Translation translationKey={"first_bill_review"} />}
                        value={billingAccount.accountFirstBillId}
                        options={accountFirstBill}
                        placeholder={`${this.props.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='billingAccountForm.billingAccount.accountFirstBillId'
                        disabled={false}
                        requiredField={true}
                    />

                    <Select
                        className="form-select required"
                        label={<Translation translationKey={"allocation_level"} />}
                        value={billingAccount.allocationLevelId}
                        options={accountLevel}
                        placeholder={`${this.props.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='billingAccountForm.billingAccount.allocationLevelId'
                        disabled={false}
                        requiredField={true}
                    />

                    <CustomSearchableDropdownWrapper
                        label={<Translation translationKey={"ap_vendor_id_capital"} />}
                        options={apVendorsByVendor}
                        selected={billingAccount.apVendorId}
                        onChange={selectedApVendor}
                        placeholder={`${this.props.toLocaleLanguage('select_placeholder')}`}
                        fieldProp='billingAccountForm.billingAccount.apVendorId'
                        tagName='apVendorId'
                        optionLabelKey={{
                            Key: 'Key',
                            Value: 'Value'
                        }}
                        maxLength={MAX_LENGTH.inputText}
                        disabled={false}

                        onSearchChange={this.searchAPVendor}
                        onLoadMore={this.loadMoreAPVendors}
                        hasMore={hasMoreAPVendors}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"remit_id_capital"} />}
                        value={billingAccount.remitId}
                        fieldProp='billingAccountForm.billingAccount.remitId'
                        disabled={false}
                        placeholder={this.props.toLocaleLanguage('enter_text_placeholder')}
                        maxLength={MAX_LENGTH.limit_15}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"requester_name"} />}
                        value={billingAccount.requesterName}
                        fieldProp='billingAccountForm.billingAccount.requesterName'
                        disabled={false}
                        placeholder={this.props.toLocaleLanguage('enter_text_placeholder')}
                        maxLength={MAX_LENGTH.inputText}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        label={<Translation translationKey={"client_name"} />}
                        value={billingAccount.clientName}
                        fieldProp='billingAccountForm.billingAccount.clientName'
                        disabled={false}
                        requiredField={true}
                        placeholder={this.props.toLocaleLanguage('enter_text_placeholder')}
                        maxLength={MAX_LENGTH.inputText}
                    />

                    <DATEPICKER_OR
                        dateOnly={true}
                        label={<Translation translationKey={"take_over_date"} />}
                        placeholder={`${this.props.toLocaleLanguage('select_date')}`}
                        startDate={billingAccount.takeOverdate}
                        selectedDate={(date) => this.props.FormChange("billingAccountForm.billingAccount.takeOverdate", date)}
                        isDisable={false}
                        requiredField={true}
                        customClass={"billing-account"}
                    />

                    <InputField
                        className="form-control"
                        type="text"
                        customWrapper="grid-col-span-2"
                        label={<Translation translationKey={"description"} />}
                        value={billingAccount.descriptions}
                        fieldProp='billingAccountForm.billingAccount.descriptions'
                        disabled={false}
                        placeholder={this.props.toLocaleLanguage('enter_text_placeholder')}
                        maxLength={MAX_LENGTH.limit_500}
                    />
                </div>
            </>
        )

    }
}

export default connect(
    state => {
        const { translation, billingAccountDetails } = state;
        const { billingAccountForm, accountLocationForm, forms: { billingAccountForm: { $form } } } = state.form

        return {
            ...translation
            , billingAccountDetails
            , billingAccountForm
            , accountLocationForm
            , $form
        };
    },
    dispatch => ({
        FormChange: (Model, value) => {
            dispatch(actions.change(Model, value))
        },
        FormLoad: (model, data) => {
            dispatch(actions.load(model, data));
        }
    })
)(BillingTransactionDetails)